import { Component, HostListener, OnInit } from '@angular/core';
import { UploadServiceService } from '../service/upload-service.service';
import { Router } from '@angular/router';
import { AuthService, AuthUser } from '../services/auth.service';
import { AdminApiService } from '../services/admin-api.service';
import {
  isAssessmentViewportSupported,
  MIN_ASSESSMENT_VIEWPORT_WIDTH
} from '../assessment-device-support';

@Component({
    selector: 'app-assessment-creator',
    templateUrl: './assessment-creator.component.html',
    styleUrls: ['./assessment-creator.component.css'],
    standalone: false
})
export class AssessmentCreatorComponent implements OnInit {
  currentUser: AuthUser | null = null;
  assessments: any[] = [];
  assessmentAttemptBlocked = false;
  loadingAttemptAccess = false;
  resumeUrl = '';
  resumePromptDismissed = sessionStorage.getItem('resumePromptDismissed') === 'true';
  assessmentScreenUnsupported = false;
  readonly minimumAssessmentViewportWidth = MIN_ASSESSMENT_VIEWPORT_WIDTH;
  private allAssessments: any[] = [];

  constructor(
    private _uploadService: UploadServiceService,
    private router: Router,
    private authService: AuthService,
    private adminApi: AdminApiService
  ) { }

  ngOnInit(): void {
    this.updateAssessmentScreenSupport();
    // Apply the visibility rule again whenever the authenticated role changes.
    this.authService.authState$.subscribe(user => {
      this.currentUser = user;
      this.updateVisibleAssessments();

      if (user?.role === 'member') {
        this.loadAttemptAccess(user.userId);
      } else {
        this.assessmentAttemptBlocked = false;
        this.loadingAttemptAccess = false;
      }
    });

    this._uploadService.getAllAssessment().subscribe((data)=>{
      if(data && 'resp' in data){
        console.log("Assessements found",data);
        // data['resp'].forEach((assessment)=>{
        //   let sections = assessment['categoryList'].map((category)=>category.type);
        //   assessment.sections = sections;
        // })
        this.allAssessments = Array.isArray(data["resp"]) ? data["resp"] : [];
        this.updateVisibleAssessments();
      }
    });
  }

  private loadAttemptAccess(userId: string): void {
    this.loadingAttemptAccess = true;
    this.adminApi.getUserById(userId).subscribe({
      next: (res) => {
        this.assessmentAttemptBlocked = res?.user?.assessmentAttemptBlocked === true;
        this.resumeUrl = res?.user?.resumeUrl || '';
        this.loadingAttemptAccess = false;
      },
      error: (err) => {
        console.error('Failed to load assessment attempt access', err);
        this.assessmentAttemptBlocked = false;
        this.resumeUrl = '';
        this.loadingAttemptAccess = false;
      }
    });
  }

  private updateVisibleAssessments(): void {
    this.assessments = this.isAdmin
      ? [...this.allAssessments]
      : this.allAssessments.filter(assessment => assessment?.state === 'PUBLISHED');
  }

  createSection(categoryList){
    console.log("create section called",categoryList);
    let str = "";
    categoryList.forEach((category)=>{
      console.log("Updatating string",str);
      str = str + category.type;
    })
    return str;
  }

  editAssessmentRoute(assessemntId){
    console.log("Assessment Id",assessemntId);
    this.router.navigate([`/assessment-builder`],{ queryParams: { "assessmentId": assessemntId}});
  }

  startAssessmentRoute(assessemntId){
    console.log("Assessment Id",assessemntId);
    this.updateAssessmentScreenSupport();
    if (this.assessmentScreenUnsupported) return;

    if (this.isMember && !this.resumeUrl) {
      this.router.navigate(['/profile'], {
        queryParams: { required: true, assessmentId: assessemntId }
      });
      return;
    }
    this.router.navigate([`/start-assessment`],{ queryParams: { "assessmentId": assessemntId}});
  }

  @HostListener('window:resize')
  onViewportResize(): void {
    this.updateAssessmentScreenSupport();
  }

  private updateAssessmentScreenSupport(): void {
    this.assessmentScreenUnsupported = !isAssessmentViewportSupported(window.innerWidth);
  }

  dismissResumePrompt(): void {
    this.resumePromptDismissed = true;
    sessionStorage.setItem('resumePromptDismissed', 'true');
  }

  get isAdmin(): boolean {
    return this.currentUser?.role === 'admin';
  }

  get isMember(): boolean {
    return this.currentUser?.role === 'member';
  }
  


}
